module.exports = __webpack_public_path__ + "static/media/018.f4ab4777.jpg";